<template>
  <el-dialog :visible="visible"
             :title="title"
             width="600px"
             custom-class="ele-dialog-form"
             :destroy-on-close="true"
             :close-on-click-modal="true"
             :close-on-press-escape="true"
             :lock-scroll="false"
             :show-close="true"
             @update:visible="updateVisible">
    <div class="">
      <div style="display: flex;justify-content: center">
        <vue-qr v-if="qrCodeSrc" style="width:250px;height:250px;" :text="qrCodeSrc" :size="250"></vue-qr>
      </div>

      <div style="display: flex;justify-content: start">
        <div>
          {{qrCodeSrc}}
        </div>
      </div>

    </div>
    <div slot="footer">
      <el-button type="primary" @click="updateVisible(false)">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import VueQr from 'vue-qr'

export default {
  name: "ShadowrocketModal",
  components: {VueQr},
  props: {
    // 弹窗是否打开
    visible: Boolean,
    // 接收的数据
    longUrl: String,
    // 接收的数据
    shortUrl: String,
    fileName: {
      type: String,
      default: "Shadowrocket二维码"
    },
  },
  data() {
    return {
      loading: false,
      reload: Math.random(),
      title: "Shadowrocket二维码",
      qrCodeSrc: undefined,
    };
  },
  watch: {},
  mounted() {
    this.renderQRCode()
  },
  computed: {},
  methods: {

    renderQRCode() {
      if (this.fileName) {
        this.title = this.fileName
      }

      let qrCodeSrc = this.shortUrl ? this.shortUrl : this.longUrl;
      qrCodeSrc = `sub://${btoa(qrCodeSrc)}`
      if (this.fileName) {
        qrCodeSrc = `${qrCodeSrc}#${encodeURIComponent(this.fileName)}`
      }

      console.log('Shadowrocket二维码路径: ' + qrCodeSrc)
      this.qrCodeSrc = qrCodeSrc
    },

    /** 更新visible */
    updateVisible(value) {
      this.$emit("update:visible", value);
    },

    /** 保存按钮操作 */
    save() {
      this.loading = true;
      // TODO 自定义操作内容

      this.updateVisible(false);
      this.$emit("done");
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
